/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UnistackNetworkListRsp } from '../models/unistack-network-list-rsp';
import { UnistackNetworkCreateRsp } from '../models/unistack-network-create-rsp';
import { UnistackNetworkCreateReq } from '../models/unistack-network-create-req';
import { UnistackSubnetListRsp } from '../models/unistack-subnet-list-rsp';
import { UnistackSubnetCreateRsp } from '../models/unistack-subnet-create-rsp';
import { UnistackSubnetCreateReq } from '../models/unistack-subnet-create-req';
import { UnistackSubnetLookupRsp } from '../models/unistack-subnet-lookup-rsp';
import { UnistackPortListRsp } from '../models/unistack-port-list-rsp';
import { UnistackPortCreateRsp } from '../models/unistack-port-create-rsp';
import { UnistackPortCreateReq } from '../models/unistack-port-create-req';
import { UnistackPortDeleteRsp } from '../models/unistack-port-delete-rsp';
import { UnistackSubnetDeleteRsp } from '../models/unistack-subnet-delete-rsp';
import { UnistackNetworkLookupRsp } from '../models/unistack-network-lookup-rsp';
import { UnistackNetworkDeleteRsp } from '../models/unistack-network-delete-rsp';
@Injectable({
  providedIn: 'root',
})
class NetworkServiceService extends __BaseService {
  static readonly NetworkListPath = '/api/unistack/v0/networks';
  static readonly NetworkCreatePath = '/api/unistack/v0/networks';
  static readonly SubnetListPath = '/api/unistack/v0/networks/{network}/subnets';
  static readonly SubnetCreatePath = '/api/unistack/v0/networks/{network}/subnets';
  static readonly SubnetLookupPath = '/api/unistack/v0/networks/{network}/subnets/{uuid}';
  static readonly PortListPath = '/api/unistack/v0/networks/{network}/{subnet}/ports';
  static readonly PortCreatePath = '/api/unistack/v0/networks/{network}/{subnet}/ports';
  static readonly PortDeletePath = '/api/unistack/v0/networks/{network}/{subnet}/ports/{uuid}';
  static readonly SubnetDeletePath = '/api/unistack/v0/networks/{network}/{uuid}';
  static readonly NetworkLookupPath = '/api/unistack/v0/networks/{uuid}';
  static readonly NetworkDeletePath = '/api/unistack/v0/networks/{uuid}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `NetworkServiceService.NetworkListParams` containing the following parameters:
   *
   * - `project`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  NetworkListResponse(params: NetworkServiceService.NetworkListParams): __Observable<__StrictHttpResponse<UnistackNetworkListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.project != null) __params = __params.set('project', params.project.toString());
    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/networks`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNetworkListRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.NetworkListParams` containing the following parameters:
   *
   * - `project`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  NetworkList(params: NetworkServiceService.NetworkListParams): __Observable<UnistackNetworkListRsp> {
    return this.NetworkListResponse(params).pipe(
      __map(_r => _r.body as UnistackNetworkListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  NetworkCreateResponse(body: UnistackNetworkCreateReq): __Observable<__StrictHttpResponse<UnistackNetworkCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/networks`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNetworkCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  NetworkCreate(body: UnistackNetworkCreateReq): __Observable<UnistackNetworkCreateRsp> {
    return this.NetworkCreateResponse(body).pipe(
      __map(_r => _r.body as UnistackNetworkCreateRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.SubnetListParams` containing the following parameters:
   *
   * - `network`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  SubnetListResponse(params: NetworkServiceService.SubnetListParams): __Observable<__StrictHttpResponse<UnistackSubnetListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.metaSort != null) __params = __params.set('meta.sort', params.metaSort.toString());
    if (params.metaOrder != null) __params = __params.set('meta.order', params.metaOrder.toString());
    if (params.metaOffset != null) __params = __params.set('meta.offset', params.metaOffset.toString());
    if (params.metaLimit != null) __params = __params.set('meta.limit', params.metaLimit.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/networks/${params.network}/subnets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackSubnetListRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.SubnetListParams` containing the following parameters:
   *
   * - `network`:
   *
   * - `meta.sort`:
   *
   * - `meta.order`:
   *
   * - `meta.offset`:
   *
   * - `meta.limit`:
   *
   * - `fields`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  SubnetList(params: NetworkServiceService.SubnetListParams): __Observable<UnistackSubnetListRsp> {
    return this.SubnetListResponse(params).pipe(
      __map(_r => _r.body as UnistackSubnetListRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.SubnetCreateParams` containing the following parameters:
   *
   * - `network`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  SubnetCreateResponse(params: NetworkServiceService.SubnetCreateParams): __Observable<__StrictHttpResponse<UnistackSubnetCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/networks/${params.network}/subnets`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackSubnetCreateRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.SubnetCreateParams` containing the following parameters:
   *
   * - `network`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  SubnetCreate(params: NetworkServiceService.SubnetCreateParams): __Observable<UnistackSubnetCreateRsp> {
    return this.SubnetCreateResponse(params).pipe(
      __map(_r => _r.body as UnistackSubnetCreateRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.SubnetLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `network`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  SubnetLookupResponse(params: NetworkServiceService.SubnetLookupParams): __Observable<__StrictHttpResponse<UnistackSubnetLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    if (params.project != null) __params = __params.set('project', params.project.toString());
    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/networks/${params.network}/subnets/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackSubnetLookupRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.SubnetLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `network`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  SubnetLookup(params: NetworkServiceService.SubnetLookupParams): __Observable<UnistackSubnetLookupRsp> {
    return this.SubnetLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackSubnetLookupRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.PortListParams` containing the following parameters:
   *
   * - `subnet`:
   *
   * - `network`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  PortListResponse(params: NetworkServiceService.PortListParams): __Observable<__StrictHttpResponse<UnistackPortListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/networks/${params.network}/${params.subnet}/ports`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackPortListRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.PortListParams` containing the following parameters:
   *
   * - `subnet`:
   *
   * - `network`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  PortList(params: NetworkServiceService.PortListParams): __Observable<UnistackPortListRsp> {
    return this.PortListResponse(params).pipe(
      __map(_r => _r.body as UnistackPortListRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.PortCreateParams` containing the following parameters:
   *
   * - `subnet`:
   *
   * - `network`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  PortCreateResponse(params: NetworkServiceService.PortCreateParams): __Observable<__StrictHttpResponse<UnistackPortCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    __body = params.body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/unistack/v0/networks/${params.network}/${params.subnet}/ports`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackPortCreateRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.PortCreateParams` containing the following parameters:
   *
   * - `subnet`:
   *
   * - `network`:
   *
   * - `body`:
   *
   * @return A successful response.
   */
  PortCreate(params: NetworkServiceService.PortCreateParams): __Observable<UnistackPortCreateRsp> {
    return this.PortCreateResponse(params).pipe(
      __map(_r => _r.body as UnistackPortCreateRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.PortDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `subnet`:
   *
   * - `network`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  PortDeleteResponse(params: NetworkServiceService.PortDeleteParams): __Observable<__StrictHttpResponse<UnistackPortDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/networks/${params.network}/${params.subnet}/ports/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackPortDeleteRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.PortDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `subnet`:
   *
   * - `network`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  PortDelete(params: NetworkServiceService.PortDeleteParams): __Observable<UnistackPortDeleteRsp> {
    return this.PortDeleteResponse(params).pipe(
      __map(_r => _r.body as UnistackPortDeleteRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.SubnetDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `network`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  SubnetDeleteResponse(params: NetworkServiceService.SubnetDeleteParams): __Observable<__StrictHttpResponse<UnistackSubnetDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    if (params.project != null) __params = __params.set('project', params.project.toString());
    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/networks/${params.network}/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackSubnetDeleteRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.SubnetDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `network`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  SubnetDelete(params: NetworkServiceService.SubnetDeleteParams): __Observable<UnistackSubnetDeleteRsp> {
    return this.SubnetDeleteResponse(params).pipe(
      __map(_r => _r.body as UnistackSubnetDeleteRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.NetworkLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  NetworkLookupResponse(params: NetworkServiceService.NetworkLookupParams): __Observable<__StrictHttpResponse<UnistackNetworkLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.project != null) __params = __params.set('project', params.project.toString());
    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/unistack/v0/networks/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNetworkLookupRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.NetworkLookupParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  NetworkLookup(params: NetworkServiceService.NetworkLookupParams): __Observable<UnistackNetworkLookupRsp> {
    return this.NetworkLookupResponse(params).pipe(
      __map(_r => _r.body as UnistackNetworkLookupRsp)
    );
  }

  /**
   * @param params The `NetworkServiceService.NetworkDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  NetworkDeleteResponse(params: NetworkServiceService.NetworkDeleteParams): __Observable<__StrictHttpResponse<UnistackNetworkDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.project != null) __params = __params.set('project', params.project.toString());
    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/unistack/v0/networks/${params.uuid}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UnistackNetworkDeleteRsp>;
      })
    );
  }
  /**
   * @param params The `NetworkServiceService.NetworkDeleteParams` containing the following parameters:
   *
   * - `uuid`:
   *
   * - `project`:
   *
   * - `account`:
   *
   * @return A successful response.
   */
  NetworkDelete(params: NetworkServiceService.NetworkDeleteParams): __Observable<UnistackNetworkDeleteRsp> {
    return this.NetworkDeleteResponse(params).pipe(
      __map(_r => _r.body as UnistackNetworkDeleteRsp)
    );
  }
}

module NetworkServiceService {

  /**
   * Parameters for NetworkList
   */
  export interface NetworkListParams {
    project?: string;
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
    fields?: Array<'field_all' | 'field_uuid' | 'field_label' | 'field_status' | 'field_type' | 'field_name' | 'field_desc' | 'field_net' | 'field_account' | 'field_project' | 'field_options'>;
    account?: string;
  }

  /**
   * Parameters for SubnetList
   */
  export interface SubnetListParams {
    network: string;
    metaSort?: string;
    metaOrder?: string;
    metaOffset?: string;
    metaLimit?: string;
    fields?: Array<'field_all' | 'field_uuid' | 'field_label' | 'field_status' | 'field_type' | 'field_name' | 'field_desc' | 'field_net' | 'field_account' | 'field_project' | 'field_options'>;
    account?: string;
  }

  /**
   * Parameters for SubnetCreate
   */
  export interface SubnetCreateParams {
    network: string;
    body: UnistackSubnetCreateReq;
  }

  /**
   * Parameters for SubnetLookup
   */
  export interface SubnetLookupParams {
    uuid: string;
    network: string;
    project?: string;
    account?: string;
  }

  /**
   * Parameters for PortList
   */
  export interface PortListParams {
    subnet: string;
    network: string;
    account?: string;
  }

  /**
   * Parameters for PortCreate
   */
  export interface PortCreateParams {
    subnet: string;
    network: string;
    body: UnistackPortCreateReq;
  }

  /**
   * Parameters for PortDelete
   */
  export interface PortDeleteParams {
    uuid: string;
    subnet: string;
    network: string;
    account?: string;
  }

  /**
   * Parameters for SubnetDelete
   */
  export interface SubnetDeleteParams {
    uuid: string;
    network: string;
    project?: string;
    account?: string;
  }

  /**
   * Parameters for NetworkLookup
   */
  export interface NetworkLookupParams {
    uuid: string;
    project?: string;
    account?: string;
  }

  /**
   * Parameters for NetworkDelete
   */
  export interface NetworkDeleteParams {
    uuid: string;
    project?: string;
    account?: string;
  }
}

export { NetworkServiceService }
